import React from 'react'
import { SearchItemList } from './SearchItemList'
import { Typography } from '@mui/material'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import InfiniteScroll from 'react-infinite-scroll-component'
import { getApp } from 'app'
import { NextPageTrigger, SearchResponseState } from '../searchState'
import { SearchResultsEndMessage } from './SearchResultsEndMessage'
import { css } from '@emotion/css'

interface Props {
  height?: number
}
export const SearchResultsList = ({ height }: Props) => {
	const searchResponse = useRecoilValue(SearchResponseState)
	const set_nextPage = useSetRecoilState(NextPageTrigger)

	if (!searchResponse) return null

	//TODO use a hash as key for each result, re-render on changed data
	const resultsList = searchResponse.results.map((item, index) => (
		<SearchItemList key={`${item.pk}-${item.title}-${item.model_name}-${item.playing_now}`} item={item} />
	))

	return (
		<InfiniteScroll
			height={height}
			scrollThreshold={0.8} //how far down to trigger load, setting this too low will pull LOTS
			dataLength={searchResponse.results.length}
			next={() => set_nextPage((prev) => ++prev)}
			hasMore={searchResponse.more_pages}
			// loader={<Box m={3}><SimpleCircularProgress /></Box>} //currently too cpu intensive for spinner...
			loader={
				<Typography align='center' variant='body1'>
          loading...
				</Typography>
			}
			endMessage={<SearchResultsEndMessage />}
			style={{fontSize: '1.6rem'}}
		>
			{resultsList}
			{/* <div className={containerStyle} {...setCyid('search-results-view-list')}>
            </div> */}
		</InfiniteScroll>
	)
}

const containerStyle = css`
  overflow-x: hidden;
  height: 100%;
  max-height: null;
  overflow: hidden;
  display: grid;
  grid-template-columns: 7fr 3fr 2fr;
`

const fullWidthStyle = css`
  grid-column-start: 1;
  grid-column-end: 4;
`

const spinnerStyle = css`
  grid-column-start: 1;
  grid-column-end: 4;
  height: 5em;
`
